const styles = theme => ({
    root: {
        margin: '0',
        padding: '0',
        overflow: 'auto'
    },
    bottom: {
        display: 'block',
        margin: '20px auto'
    }
});

export default styles;
